// src/api/dashboardActions.js
import axios from "axios";
import API_BASE_URL from "config/api";

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
  },
});

// ✅ 목록 조회
export const fetchDashboardActions = async (interval) => {
  const res = await axios.get(
    `${API_BASE_URL}/api/products/dashboard/actions/?interval=${interval}`,
    authHeaders()
  );
  return res.data;
};

// ✅ 완료 처리
export const completeDashboardAction = async (id) => {
  return axios.patch(
    `${API_BASE_URL}/api/products/dashboard/actions/${id}/complete/`,
    {},
    authHeaders()
  );
};

// ✅ 완료 → 다시 pending (UNDO)
export const undoDashboardAction = async (id) => {
  return axios.patch(
    `${API_BASE_URL}/api/products/dashboard/actions/${id}/undo/`,
    {},
    authHeaders()
  );
};

// ✅ 무시(dismiss)
export const dismissDashboardAction = async (id) => {
  return axios.patch(
    `${API_BASE_URL}/api/products/dashboard/actions/${id}/dismiss/`,
    {},
    authHeaders()
  );
};

// (옵션) 유저 직접 추가
export const createDashboardAction = async (payload) => {
  return axios.post(
    `${API_BASE_URL}/api/products/dashboard/actions/`,
    payload,
    authHeaders()
  );
};

export const restoreDashboardAction = async (id) => {
  return axios.patch(
    `${API_BASE_URL}/api/products/dashboard/actions/${id}/restore/`,
    {},
    authHeaders()
  );
};